import { makeStyles } from '@material-ui/core/styles'

export const styles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  tableBody: {
    boxShadow:
      '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
    borderRadius: '23px',
  },
})
